function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.81681 17.8184H0.3C0.134315 17.8184 -0.000222972 17.6836 0.00195508 17.5179C0.0214114 16.038 0.18281 15.0354 0.338728 14.4377C0.381739 14.2728 0.559159 14.1885 0.718585 14.2486C0.980866 14.3476 1.31453 14.4731 1.59744 14.5786C1.76793 14.6422 1.84587 14.8424 1.78036 15.0122C1.51554 15.6984 1.25442 16.8553 1.11341 17.573C1.08551 17.7151 0.961567 17.8184 0.81681 17.8184Z",
  fill: "#D18F1F"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.43489 13.1094L1.34757 12.4828C1.21734 12.4078 1.16204 12.2477 1.22595 12.1116C1.69745 11.1082 2.53631 10.077 3.18897 9.46046C3.31006 9.34607 3.50067 9.36241 3.60772 9.49005L4.58357 10.6536C4.69889 10.7911 4.66855 10.9984 4.5283 11.1103C3.89216 11.6181 3.233 12.4276 2.85142 13.0055C2.76047 13.1433 2.57791 13.1918 2.43489 13.1094Z",
  fill: "#D18F1F"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.09048 8.25946L5.95701 9.77086C6.03958 9.91487 6.22358 9.9652 6.37461 9.89629C6.96446 9.62719 7.97592 9.30657 8.77697 9.17026C8.94775 9.1412 9.06782 8.98078 9.03772 8.81018L8.66664 6.70738C8.63738 6.54158 8.47758 6.43205 8.31478 6.47493C7.33416 6.73325 5.96087 7.34915 5.17291 7.8795C5.04826 7.96339 5.01574 8.12912 5.09048 8.25946Z",
  fill: "#D18F1F"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6133 6.3101V8.74108C10.6133 8.91827 10.7662 9.05727 10.9434 9.06096C11.6898 9.0765 12.6856 9.32443 13.3029 9.543C13.466 9.60074 13.6498 9.521 13.7088 9.35838L14.6984 6.63149C14.7546 6.47664 14.6753 6.30544 14.5157 6.26454C13.5774 6.02409 11.9113 5.96822 10.8905 6.01527C10.7336 6.0225 10.6133 6.15312 10.6133 6.3101Z",
  fill: "#D18F1F"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7156 7.27973L15.1244 9.9914C15.0358 10.1425 15.0945 10.3377 15.244 10.4289C15.8305 10.787 16.6299 11.4478 17.1062 11.9947C17.2203 12.1256 17.4197 12.1514 17.5532 12.0403C18.2068 11.4963 19.3361 10.5484 20.2181 9.78327C20.3468 9.67161 20.356 9.47513 20.234 9.35615C19.1998 8.34737 17.8505 7.54425 17.0976 7.16368C16.9598 7.09404 16.7937 7.14658 16.7156 7.27973Z",
  fill: "#D18F1F"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.62 11.4835L18.3598 13.4026C18.219 13.4855 18.1712 13.6654 18.2434 13.8119C18.8923 15.128 19.0118 16.655 18.9815 17.514C18.9752 17.6916 19.1143 17.8451 19.292 17.8451H23.6998C23.8655 17.8451 24.0004 17.7111 23.9933 17.5455C23.9059 15.4811 22.944 13.0829 22.0193 11.5793C21.9354 11.443 21.758 11.4023 21.62 11.4835Z",
  fill: "#D18F1F"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1859 15.3728L15.2802 11.6851L13.2168 17.4553C12.9075 18.3625 11.4436 19.3316 10.1859 18.2801C8.92815 17.2285 9.44363 15.8264 10.1859 15.3728Z",
  fill: "#D18F1F"
});
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.d9e455ee86d2df3a314c169cc3edbcec.svg";
export { ForwardRef as ReactComponent };